class Tabs {
	constructor() {
		this.selectors = {
			document: document,
		};
		this.init();
		this.timeout_1 = null;
		this.timeout_2 = null;
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {

		this.nodes.document.ready(function() {
			$('.js-popup-gallery').magnificPopup({
				delegate: 'a',
				type: 'image',
				tLoading: 'Loading image #%curr%...',
				mainClass: 'mfp-img-mobile',
				gallery: {
					enabled: true,
					navigateByImgClick: true,
					preload: [0,1]
				},
				image: {
					tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
				}
			});

			//  video
		    $(document).on("mouseup", '.js-gallery-video', function(event) {
		        event.preventDefault();
		        var target = $(event.currentTarget);

		        target.magnificPopup({
		            type: 'iframe',
		            iframe:{
		                patterns:{
		                    youtube:{
		                        index: 'youtube.com/',
		                        id: '/',
		                        src: '//www.youtube.com/embed/%id%'
		                    },
		                    youtu:{
		                        index: 'youtu.be/',
		                        id: 'v=',
		                        src: '//www.youtube.com/embed/%id%'
		                    },
		                    vimeo:{
		                        index: 'vimeo.com/',
		                        id: '/',
		                        src: '//player.vimeo.com/video/%id%'
		                    },
		                    play:{
		                        index: 'play.md/',
		                        id: '/',
		                        src: '//play.md/embed/%id%?title=false'
		                    }
		                }
		            }
		        });

		    });
		});


	}
}
new Tabs();